export default {
  name: 'logo',
  data() {
    return {
      changeLogo: false
    };
  },
  created() {
    console.log("changeLogo", this.changeLogo);
    // 获取sessionStorage中的customerId
    let customerId = sessionStorage.getItem("customerId");
    console.log("customerId", customerId);
    if (customerId == 119) {
      this.changeLogo = true;
      console.log("changeLogo", this.changeLogo);
    }
  }
};